import { graphql } from "react-relay";

export const RemoveUserGroupMutation = graphql`
  mutation RemoveUserGroupMutation($input: RemoveUserGroupInput!) {
    removeUserGroup(input: $input) {
      removed {
        id @deleteRecord
      }
    }
  }
`;
